/* eslint-disable require-jsdoc */
import {callLambda} from '@/lib/api/lambda';
import socket from '@/lib/socket/authSocket.js';
import errorMapping from '@/constant/error';
import {formToPayload, responseToLobby} from './pvpTeacherLobbyMapper';

function quickMatch({boardSize, hasHandicap}) {
  const params = {
    boardSize,
    hasHandicap,
  };
  return callLambda({
    category: 'pvp',
    method: 'get',
    apiName: 'quickMatch',
    params,
  })
    .then((res) => {
      return res.data || '';
    })
    .catch((error) => {
      return error;
    });
}

/**
 * 快速配對-積分賽
 * @param {String} boardSize 棋盤大小
 * @returns {Promise} promise
 */
function quickMatchByElo({boardSize}) {
  const data = {
    boardSize,
  };
  return callLambda({
    category: 'pvp',
    method: 'post',
    apiName: 'quickMatchByElo',
    data,
  })
    .then((res) => {
      return res.data || '';
    })
    .catch((error) => {
      return error;
    });
}

/**
 * 快速配對-停止配對
 * @param {String} boardSize 棋盤大小
 * @returns {Promise} promise
 */
function stopMatchByElo(boardSize) {
  return callLambda({
    category: 'pvp',
    method: 'post',
    apiName: 'stopMatchByElo',
    data: {boardSize},
  })
    .then((res) => {
      return res.data || '';
    })
    .catch((error) => {
      return error;
    });
}

/**
 * 取得對戰單一棋譜資料
 * @param {String} id id
 * @returns {Promise} promise
 */
function getPvpKifu(id) {
  return callLambda({
    category: 'pvp',
    apiName: id,
    method: 'get',
  }).then((result) => {
    return result.data;
  });
}

/**
 * 取得房間資料
 * @param {String} lobbyId lobbyId
 * @returns {Promise} promise
 */
function getPvpLobby(lobbyId) {
  return callLambda({
    category: 'pvp',
    apiName: `lobbies/${lobbyId}`,
    method: 'get',
  }).then((result) => {
    return result.data;
  });
}

function createLobby(data) {
  return new Promise((resolve, reject) => {
    socket.once(
      socket.ResponseEventEnum.PVP_CREATE_LOBBY_SUCCESSFULLY,
      (result) => resolve(result?.data)
    );
    socket.onError(socket.SendEventEnum.PVP_CREATE_LOBBY, (result) => {
      const message = result.message;
      let errorMessage = null;
      switch (message) {
        case errorMapping.UNFINISHED_GAME:
          errorMessage = '仍有進行中的對局';
          break;
        default:
          errorMessage = '發生未知錯誤';
          break;
      }
      reject(new Error(errorMessage));
    });
    socket.send({
      action: 'pvp',
      pvpAction: socket.SendEventEnum.PVP_CREATE_LOBBY,
      data,
    });
  });
}

function enterLobby(lobbyId) {
  return new Promise((resolve, reject) => {
    socket.once(
      socket.ResponseEventEnum.PVP_UPDATE_LOBBY_SUCCESSFULLY,
      resolve
    );
    socket.onError(socket.SendEventEnum.PVP_ENTER_LOBBY, (result) => {
      const message = result.message;
      let errorMessage = null;
      switch (message) {
        case errorMapping.NO_PVP_LOBBY:
          errorMessage = '房間不存在';
          break;
        case errorMapping.NO_PVP_LOBBY:
          errorMessage = '房間不存在';
          break;
        case errorMapping.SELF_CREATED_LOBBY:
          errorMessage = '無法加入自己創建的房間';
          break;
        case errorMapping.THE_LOBBY_IS_FULL:
          errorMessage = '房間已滿';
          break;
        case errorMapping.INCORRECT_USER:
          errorMessage = '無法加入該房間';
          break;
        default:
          errorMessage = '發生未知錯誤';
      }
      reject(new Error(errorMessage));
    });
    socket.send({
      action: 'pvp',
      pvpAction: socket.SendEventEnum.PVP_ENTER_LOBBY,
      data: {
        lobbyId,
      },
    });
  });
}

function startPvpGame(lobbyId) {
  return new Promise((resolve, reject) => {
    socket.once(socket.ResponseEventEnum.PVP_GAME_STARTED, resolve);
    socket.onError(socket.SendEventEnum.PVP_START_GAME, (result) => {
      const message = result.message;
      let errorMessage = null;
      switch (message) {
        case errorMapping.NO_PVP_LOBBY:
          errorMessage = '房間不存在';
          break;
        case errorMapping.INCORRECT_USER:
          errorMessage = '你沒有開始權限';
          break;
        case errorMapping.SOME_USER_IS_NOT_READY:
          errorMessage = '有玩家尚未準備';
          break;
        case errorMapping.HAS_UNFINISHED_GAME:
          errorMessage = '有玩家有未完成的對局';
          break;
        case errorMapping.LOBBY_NOT_STARTED:
          errorMessage = '對局尚未開始，請於指定時間開始';
          break;
        default:
          errorMessage = '發生未知錯誤';
      }
      reject(new Error(errorMessage));
    });
    socket.send({
      action: 'pvp',
      pvpAction: socket.SendEventEnum.PVP_START_GAME,
      data: {
        lobbyId,
      },
    });
  });
}

function setIsReady(lobbyId, isReady) {
  return new Promise((resolve, reject) => {
    socket.once(
      socket.ResponseEventEnum.PVP_UPDATE_LOBBY_SUCCESSFULLY,
      resolve
    );
    socket.onError(socket.SendEventEnum.PVP_SET_IS_READY, (result) => {
      const message = result.message;
      let errorMessage = null;
      switch (message) {
        case errorMapping.NO_PVP_LOBBY:
          errorMessage = '房間不存在';
          break;
        case errorMapping.INCORRECT_USER:
          errorMessage = '你沒有權限';
          break;
        case errorMapping.SOME_USER_IS_NOT_READY:
          errorMessage = '有玩家尚未準備';
          break;
        case errorMapping.HAS_UNFINISHED_GAME:
          errorMessage = '有未完成的對局';
          break;
        default:
          errorMessage = '發生未知錯誤';
      }
      reject(new Error(errorMessage));
    });
    socket.send({
      action: 'pvp',
      pvpAction: socket.SendEventEnum.PVP_SET_IS_READY,
      data: {
        lobbyId,
        isReady,
      },
    });
  });
}

function removeOpponent(lobbyId) {
  return new Promise((resolve, reject) => {
    socket.once(
      socket.ResponseEventEnum.PVP_UPDATE_LOBBY_SUCCESSFULLY,
      resolve
    );
    socket.onError(socket.SendEventEnum.PVP_REMOVE_OPPONENT, (result) => {
      const message = result.message;
      let errorMessage = null;
      switch (message) {
        case errorMapping.NOT_IN_ANY_LOBBY:
        case errorMapping.NO_PVP_LOBBY:
          errorMessage = '房間不存在';
          break;
        case errorMapping.INCORRECT_USER:
          errorMessage = '你沒有權限';
          break;
        default:
          errorMessage = '發生未知錯誤';
      }
      reject(new Error(errorMessage));
    });
    socket.send({
      action: 'pvp',
      pvpAction: socket.SendEventEnum.PVP_REMOVE_OPPONENT,
      data: {
        lobbyId,
      },
    });
  });
}

function getPvpUnfinishedGame() {
  return new Promise((resolve, reject) => {
    socket.once(socket.ResponseEventEnum.PVP_EXIST_PVP_GAME, (result) => {
      const data = result.data;
      resolve(data);
    });
    socket.onError(socket.SendEventEnum.PVP_GET_UNFINISHED_GAME, () => {
      const errorMessage = '發生未知錯誤';
      reject(new Error(errorMessage));
    });
    socket.send({
      action: 'pvp',
      pvpAction: socket.SendEventEnum.PVP_GET_UNFINISHED_GAME,
    });
  });
}

function getPvpSpectateGame(gameId) {
  return new Promise((resolve, reject) => {
    socket.once(
      socket.ResponseEventEnum.PVP_SPECTATE_SUCCESSFULLY,
      (result) => {
        const data = result.data;
        resolve(data);
      }
    );
    socket.onError(socket.SendEventEnum.PVP_SPECTATE, () => {
      const errorMessage = '發生未知錯誤';
      reject(new Error(errorMessage));
    });
    socket.send({
      action: 'pvp',
      pvpAction: socket.SendEventEnum.PVP_SPECTATE,
      data: {
        gameId,
      },
    });
  });
}

/**
 * @returns {Promise<Array>} lobby list
 */
async function getLobbies({createdBy, username, limit} = {}) {
  const params = {};
  if (createdBy) params.createdBy = createdBy;
  if (username) params.username = username;
  if (limit) params.limit = limit;
  const res = await callLambda({
    category: 'pvp',
    method: 'get',
    apiName: 'lobbies',
    params,
  });
  return (res.data?.lobbies ?? []).map(responseToLobby);
}

async function getGames({
  createdBy,
  username,
  isCreatedByThirdParty,
  limit,
} = {}) {
  const params = {};
  if (createdBy) params.createdBy = createdBy;
  if (username) params.username = username;
  if (isCreatedByThirdParty !== undefined) {
    params.isCreatedByThirdParty = isCreatedByThirdParty;
  }
  if (limit) params.limit = limit;

  const res = await callLambda({
    category: 'pvp',
    method: 'get',
    apiName: 'games',
    params,
  });
  return (res.data?.games ?? []).map(responseToLobby);
}

async function updateLobby(lobbyId, formData) {
  return callLambda({
    category: 'pvp',
    method: 'put',
    apiName: `lobbies/${lobbyId}`,
    data: formToPayload(formData),
  });
}

/**
 * @param {String} lobbyId lobby ID
 * @returns {Promise} API response
 */
async function deleteLobby(lobbyId) {
  return callLambda({
    category: 'pvp',
    method: 'delete',
    apiName: `lobbies/${lobbyId}`,
  });
}

/**
 * @param {Array} forms array of form objects from StudentPvpSettingModal
 * @returns {Promise} API response
 */
export async function createLobbies(forms) {
  return callLambda({
    category: 'pvp',
    method: 'post',
    apiName: 'lobbies/v2',
    data: {lobbies: forms.map(formToPayload)},
  });
}

export default {
  quickMatch,
  getPvpKifu,
  getPvpLobby,
  quickMatchByElo,
  stopMatchByElo,
  createLobby,
  enterLobby,
  startPvpGame,
  setIsReady,
  removeOpponent,
  getPvpUnfinishedGame,
  getPvpSpectateGame,

  getLobbies,
  getGames,
  updateLobby,
  deleteLobby,
};
